export default {"src":"/_next/static/media/dot-pattern.39d8621a.svg","height":228,"width":205,"blurWidth":0,"blurHeight":0};